import React from "react";
export const renderStyledText = (text) => {
  if (typeof text !== "string") return "";

  let modified = text.replace(/<b>(.*?)<\/b>/g, "<strong>$1</strong>");
  modified = modified.replace(/<i>(.*?)<\/i>/g, "<em>$1</em>");
  return modified;
};

export const renderBlocks = (blocks) => {
  return blocks.map((block, index) => {
    const alignment = block?.tunes?.alignment?.alignment || "left";

    switch (block.type) {
      case "header":
        const level = block.data.level || 3;
        return React.createElement(
          `h${level}`,
          {
            key: index,
            className: level === 1 ? "page-title" : "bold",
            style: { textAlign: alignment, marginBottom: "20px", marginTop: "25px" },
            dangerouslySetInnerHTML: { __html: block.data.text },
          },
        );

      case "paragraph":
        return (
          <div
            key={index}
            style={{ textAlign: alignment, marginBottom: "20px" }}
            dangerouslySetInnerHTML={{ __html: renderStyledText(block.data.text) }}
          />
        );

      case "table":
        const rows = block.data.content || [];
        return (
          <table key={index} className="w-tbl-sla">
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex} className={rowIndex % 2 === 0 ? "even" : "odd"}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex} className={cellIndex > 0 ? "text-center" : ""}>
                      <div dangerouslySetInnerHTML={{ __html: renderStyledText(cell) }} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        );

      case "list":
        const { style = 'unordered', items = [], content = [] } = block.data;
        const Tag = style === "ordered" ? "ol" : "ul";
        // Normalize to array of strings
        const listItems =
          Array.isArray(items) && items.length > 0
            ? items.map((li) =>
                typeof li === 'string' ? li : typeof li === 'object' && 'content' in li ? li.content : ''
              )
            : Array.isArray(content)
              ? content.map((c) => (Array.isArray(c) ? c.join(' ') : c))
              : [];
        return (
          <Tag key={index} className="list">
            {listItems.map((text, itemIndex) => (
              <li key={itemIndex} dangerouslySetInnerHTML={{ __html: renderStyledText(text) }} />
            ))}
          </Tag>
        );

      default:
        return null;
    }
  });
};

export const renderBlocksHero = (blocks) => {
  return blocks.map((block, index) => {
    const alignment = block?.tunes?.alignment?.alignment || "left";

    switch (block.type) {
      case "header":
        const level = block.data.level || 3;
        return React.createElement(
          `h${level}`,
          {
            key: index,
            className: level === 1 ? "page-title" : "bold",
            style: { textAlign: alignment },
            dangerouslySetInnerHTML: { __html: block.data.text },
          },
        );

      case "paragraph":
        return (
          <p
            key={index}
            style={{ textAlign: alignment }}
            dangerouslySetInnerHTML={{ __html: renderStyledText(block.data.text) }}
          />
        );

      case "table":
        const rows = block.data.content || [];
        return (
          <table key={index} className="w-tbl-sla">
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex} className={rowIndex % 2 === 0 ? "even" : "odd"}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex} className={cellIndex > 0 ? "text-center" : ""}>
                      <div dangerouslySetInnerHTML={{ __html: renderStyledText(cell) }} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        );

      case "list":
        const { style = 'unordered', items = [], content = [] } = block.data;
        const Tag = style === "ordered" ? "ol" : "ul";
        // Normalize to array of strings
        const listItems =
          Array.isArray(items) && items.length > 0
            ? items.map((li) =>
                typeof li === 'string' ? li : typeof li === 'object' && 'content' in li ? li.content : ''
              )
            : Array.isArray(content)
              ? content.map((c) => (Array.isArray(c) ? c.join(' ') : c))
              : [];
        return (
          <Tag key={index} className="list">
            {listItems.map((text, itemIndex) => (
              <li key={itemIndex} dangerouslySetInnerHTML={{ __html: renderStyledText(text) }} />
            ))}
          </Tag>
        );

      default:
        return null;
    }
  });
};